"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const Month_1 = __importDefault(require("../datastore/models/Month"));
const AccountNumberTag_1 = __importDefault(require("../datastore/models/AccountNumberTag"));
const EnumsTs_1 = require("../models/EnumsTs");
const AccountItem_1 = __importDefault(require("../datastore/models/AccountItem"));
const moment = require("moment");
const Formatter_1 = __importDefault(require("../Formatter"));
const Enums_1 = require("../models/Enums");
var FlattenAccountData;
(function (FlattenAccountData) {
    function generateAccountNumberTag(tag, accountId) {
        let accountNumber;
        if (tag.isTotal) {
            accountNumber = tag.name;
        }
        else if (tag.code == EnumsTs_1.TagCode.IS_NetProfit) {
            accountNumber = Enums_1.SpecialAccountItems.NetProfit.Number;
        }
        else {
            if (accountId === undefined) {
                throw new Error('no account id provided');
            }
            accountNumber = `${tag.code}[${accountId}]`;
        }
        return new AccountNumberTag_1.default({
            tag_id: tag.id,
            account_number: accountNumber,
            tag: tag,
        });
    }
    function flattenAccountData(account, months, tagCategories) {
        const tags = tagCategories.reduce((accum, category) => accum.concat(category.tags), []);
        const flattenedAccountNumberTags = tags.map(tag => generateAccountNumberTag(tag, account.id));
        const flattenedMonths = months.map(month => {
            if (month.is_forecast) {
                throw new Error('unexpected forecast month');
            }
            const flattenedAccountItems = flattenedAccountNumberTags.map(accountNumberTag => {
                const value = month.account_items.reduce((total, accountItem) => {
                    if (accountItem.tag_id === accountNumberTag.tag_id) {
                        return total + accountItem.Value;
                    }
                    return total;
                }, 0);
                return new AccountItem_1.default({
                    name: `${accountNumberTag.tag.name} (${account.business_name})`,
                    value,
                    account_number: accountNumberTag.account_number,
                    month_id: month.id,
                    tag_id: accountNumberTag.tag.id,
                });
            });
            return new Month_1.default({
                date: month.date,
                account_items: flattenedAccountItems,
                is_forecast: false,
            });
        });
        return {
            months: flattenedMonths,
            accountNumberTags: flattenedAccountNumberTags,
        };
    }
    FlattenAccountData.flattenAccountData = flattenAccountData;
    function isSingletonTag(tag) {
        return tag.isTotal || tag.code === EnumsTs_1.TagCode.IS_NetProfit;
    }
    function generateAggregateData(accounts, tagCategories) {
        const accountsWithData = accounts.filter(account => account.months.length > 12 && account.accountNumberTags.length > 0);
        const tags = tagCategories.reduce((accum, category) => accum.concat(category.tags), []);
        // aggregated Account Number Tags from all accounts, with totals omitted
        const mergedAccountNumberTags = accountsWithData.reduce((accum, account) => accum.concat(account.accountNumberTags), [])
            .filter(accountNumberTag => accountNumberTag.tag.isTotal !== true && accountNumberTag.tag.code !== EnumsTs_1.TagCode.IS_NetProfit);
        // Account Number Tags for totals and net profit
        const totalAccountNumberTags = tags.filter(isSingletonTag).map(tag => generateAccountNumberTag(tag));
        const aggregatedAccountNumberTags = mergedAccountNumberTags.concat(totalAccountNumberTags);
        const allMonths = accountsWithData.reduce((accum, account) => accum.concat(account.months), []);
        if (allMonths.length === 0) {
            return {
                months: [],
                accountNumberTags: [],
            };
        }
        const oldestDates = accountsWithData.map(data => data.months[0].Date);
        const newestDatesDates = accountsWithData.map(data => data.months.slice(-1)[0].Date);
        // earliest date present in any account
        const startDate = oldestDates.reduce((accum, date) => {
            return moment.min(accum, date);
        });
        // earliest date present in all accounts
        const endDate = newestDatesDates.reduce((accum, date) => {
            return moment.min(accum, date);
        });
        if (!startDate.isBefore(endDate)) {
            throw new Error('month range error');
        }
        const numMonths = endDate.diff(startDate, 'months') + 1;
        const dates = new Array(numMonths).fill(startDate).map((date, index) => date.clone().add(index, 'months'));
        const aggregatedMonths = dates.map(date => {
            const dateString = Formatter_1.default.momentToServerDateFormat(date);
            const matchingMonths = allMonths.filter(month => month.date === dateString);
            const accountItemsForMonths = matchingMonths.reduce((accum, month) => accum.concat(month.account_items), []);
            const accountItemsForMonthsWithoutTotals = accountItemsForMonths.filter(accountItem => totalAccountNumberTags.find(it => it.tag_id === accountItem.tag_id) === undefined);
            const totalItems = totalAccountNumberTags.map(accountNumberTag => {
                const value = accountItemsForMonths.reduce((total, accountItem) => {
                    if (accountItem.tag_id === accountNumberTag.tag_id) {
                        return total + accountItem.Value;
                    }
                    return total;
                }, 0);
                return new AccountItem_1.default({
                    name: accountNumberTag.tag.name,
                    value,
                    account_number: accountNumberTag.account_number,
                    tag_id: accountNumberTag.tag.id,
                });
            });
            return new Month_1.default({
                date: dateString,
                is_forecast: false,
                account_items: accountItemsForMonthsWithoutTotals.concat(totalItems),
            });
        });
        return {
            months: aggregatedMonths,
            accountNumberTags: aggregatedAccountNumberTags,
        };
    }
    FlattenAccountData.generateAggregateData = generateAggregateData;
})(FlattenAccountData || (FlattenAccountData = {}));
module.exports = FlattenAccountData;
